@charset "UTF-8";
.dialogHeader {
  padding-bottom: 10px;
}

.doubleCheckmarkIcon {
  height: 1.5em;
  width: 2.25em;
  mask: url("./images/read.svg") no-repeat center;
  mask-size: 1.5em;
  background-color: var(--messageStatusIcon);
}

.formattedMessageInfo {
  margin: 10px;
  font-size: 0.95em;
  padding: 5px 0px;
}

.errorRow {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0 10px 14px;
  padding: 10px 14px;
  border-radius: 8px;
  background-color: color-mix(in srgb, var(--errorColor) 12%, transparent);
  color: var(--errorColor);
}

.errorIcon::before {
  content: "⚠";
  font-weight: 700;
}

.errorText {
  font-weight: 500;
  word-break: break-word;
}

.infoRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 2px 20px;
}

.infoLabel {
  min-width: 200px;
  flex-shrink: 0;
}

.infoValue {
  text-align: right;
  flex-shrink: 0;
}

.readByHeader {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;
}

.readReceiptFormatted {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 20px);
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 6px;
  font: inherit;
  color: inherit;
  text-align: start;
  margin-left: 10px;
}
.readReceiptFormatted:hover {
  background-color: var(--chatListItemBgHover);
}

.readReceiptLeft {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.contactName {
  font-weight: normal;
}